import { useEffect, useState } from 'react';
import FadeIn from '../../../../components/Animation/FadeIn';
import Paragraph from '../../../../components/Typography/Paragraph';
import { Loader, MapPin, Heart, ChevronLeft, Edit2, Trash } from "react-feather";
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../../../config/axios';
import { api } from '../../../../config/api';
import { serialize } from 'object-to-formdata';
import { RoutePaths } from '../../../../config/routes';
import { Link } from 'react-router-dom';
import MoreDropDown from '../../../../components/MoreDropDown';
import FavoriteStepForm from '../../../../components/Favorite/FavoriteStep/Form';
import ModalBasic from '../../../../components/Modal/Basic';
import Heading from '../../../../components/Typography/Heading';
import Button from '../../../../components/Button';
var DashboardFavoriteList = function () {
    var _a;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(), list = _c[0], setList = _c[1];
    var listId = useParams().listId;
    var navigate = useNavigate();
    var _d = useState(false), showEdit = _d[0], setShowEdit = _d[1];
    var _e = useState(false), showDelete = _e[0], setShowDelete = _e[1];
    var loadFavoritesList = function (showLoader) {
        if (showLoader === void 0) { showLoader = false; }
        setLoading(true);
        loadList();
    };
    var loadList = function () {
        if (listId) {
            axiosInstance.get(api.favorites.one(parseInt(listId))).then(function (_a) {
                var data = _a.data;
                setList(data);
                setLoading(false);
            });
        }
    };
    var removeItem = function (profile) {
        axiosInstance.post(api.favorites.removeProfile, serialize({
            id: listId,
            profiles: profile.id
        })).then(function (_a) {
            var data = _a.data;
            setList(data);
        });
    };
    var deleteList = function () {
        axiosInstance.post(api.favorites.remove, serialize({
            id: listId
        })).then(function () {
            navigate(RoutePaths.DASHBOARD_FAVORITES);
        });
    };
    useEffect(function () {
        loadFavoritesList();
    }, []);
    var onSuccessEdit = function () {
        loadList();
        setShowEdit(false);
    };
    return (<FadeIn>
      <div className="my-10 grid gap-6 lg:my-20 lg:grid-cols-12">
        <div className="lg:col-span-10 lg:col-start-2 xl:col-span-8 xl:col-start-3">

          {loading && (<div className="flex items-center justify-center p-24">
              <Loader size={30} className="animate-spin-loader text-brand-01"/>
            </div>)}

          {list && (<>
              <div className="flex justify-between relative items-center mb-8">
                <Link to={RoutePaths.DASHBOARD_FAVORITES}>
                  <ChevronLeft size={24}/>
                </Link>
                <Paragraph className="font-medium">
                  {list.name}
                </Paragraph>

                <MoreDropDown>
                  <button className="flex items-center gap-2" onClick={function () { return setShowEdit(true); }}>
                    <Edit2 size={16}/> Modifier
                  </button>
                  <button className="flex items-center gap-2" onClick={function () { return setShowDelete(true); }}>
                    <Trash size={16}/> Supprimer
                  </button>
                </MoreDropDown>
              </div>

              {((_a = list.detailedProfiles) === null || _a === void 0 ? void 0 : _a.length) ?
                list.detailedProfiles.map(function (profile) {
                    var _a, _b;
                    return (<div key={profile.id} className={"p-4 border border-gray-200 flex rounded-lg justify-between items-start mb-3 last:mb-0 flex"}>
                        <div className={"flex items-start"}>
                          <a href={profile.url}>
                            <img width="56" height="56" className="rounded-full w-14 h-14 object-cover" src={profile.avatar_small} alt={profile.full_name}/>
                          </a>
                          <div className={"ml-3"}>
                            <a href={profile.url}>
                              <div className="text-base font-medium">{profile.full_name}</div>
                              <div className={"text-xs"}>{profile.profile_title}</div>
                              {((_a = profile.location) === null || _a === void 0 ? void 0 : _a.address) &&
                            <div className={"flex items-center mt-3 text-xs"}>
                                  <MapPin size={14} className={"mr-1.5"}/>
                                  {(_b = profile.location) === null || _b === void 0 ? void 0 : _b.address}
                                </div>}
                            </a>
                          </div>
                        </div>
                        <button onClick={function () { return removeItem(profile); }}>
                          <Heart size={20} className="fill-brand-01"/>
                        </button>
                      </div>);
                })
                : <Paragraph className="text-center text-gray-400 p-4">Aucun profil dans cette liste.</Paragraph>}
            </>)}

        </div>
      </div>
      <ModalBasic noSpace={true} handleClose={function () { return setShowEdit(false); }} open={showEdit} subWrapperClassName="p-6 overflow-hidden" iconClassName="m-6 top-1">
        <FavoriteStepForm title="Modifier" onSuccess={onSuccessEdit} onCancel={function () { return setShowEdit(false); }} favoriteList={list}/>
      </ModalBasic>
      <ModalBasic handleClose={function () { return setShowDelete(false); }} open={showDelete} subWrapperClassName="p-6 overflow-hidden" iconClassName="m-6 top-1">
        <div className="flex flex-col items-center gap-10">
          <Heading level={2} type="h5" className="text-center">
            Souhaitez-vous vraiment supprimer cette liste&nbsp;?
          </Heading>
          <div className="flex gap-6">
            <Button onClick={deleteList} type="outlined" alert="danger">
              Supprimer
            </Button>
            <Button onClick={function () { return setShowDelete(false); }} type="outlined">
              Annuler
            </Button>
          </div>
        </div>
      </ModalBasic>
    </FadeIn>);
};
export default DashboardFavoriteList;
